import { render, staticRenderFns } from "./PublicationsByThemeBarChart.vue?vue&type=template&id=ae64f12a&"
import script from "./PublicationsByThemeBarChart.vue?vue&type=script&lang=js&"
export * from "./PublicationsByThemeBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports